module.exports = __webpack_public_path__ + "img/solution_1.9ff25216.png";